// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__QHakv","containerQuiz":"Quiz_containerQuiz__+lTpl"};